import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { SolicitacoesService } from '../shared/service/solicitacoes/solicitacoes.service';
import { Emissao } from '../shared';
import { MatDialogRef, MatDialog } from '@angular/material';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilService } from '../shared/service/util/util.service';

@Component({
  selector: 'app-confirmar-emissao',
  templateUrl: './confirmar-emissao.component.html',
  styleUrls: ['./confirmar-emissao.component.css']
})
export class ConfirmarEmissaoComponent implements OnInit {

  emissao: Emissao;
  paginasTermo:string[] = [];
  hide: boolean = true;
  showSpinner: boolean = false;
  codigoAutenticacao: string;
  numeroPedido: number;
  idAgenteRegistro: number;
  pedidoEncontrado: boolean = false;
  toggleButton: boolean = true;

  @ViewChild('termoDialog', { static: true }) termoDialog: TemplateRef<any>;
  private termoDialogRef: MatDialogRef<TemplateRef<any>>;

  @ViewChild('concluirEmissao', { static: true }) concluirEmissaoDialog: TemplateRef<any>;
  private concluirEmissaoDialogRef: MatDialogRef<TemplateRef<any>>;

  public maskOfTelefone = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  
  constructor(private solicitacoesService: SolicitacoesService,
    private route: ActivatedRoute,
    private utilService: UtilService,
    private router: Router,
    private dialog: MatDialog) { 
  }

  ngOnInit() {
    this.emissao = new Emissao();
   
    this.route.params.subscribe(params => {
      this.codigoAutenticacao = params["codigoAutenticacao"];
      
      this.numeroPedido = +this.codigoAutenticacao.split('.')[3];
      this.idAgenteRegistro = +this.codigoAutenticacao.split('.')[2];
      this.emissao.numeroPedido = this.numeroPedido.toString(); 
      
      this.consultarPedido();
    });
  }
  
  consultarPedido() {
    this.showSpinner = true;
    this.solicitacoesService.consultarPedido(this.numeroPedido.toString(), this.codigoAutenticacao).subscribe(
      res => {
        this.emissao = res;

        this.emissao.email = this.emissao.email.toLowerCase();
        
        if (this.emissao.telefone == "0") {
          this.emissao.telefone = "";
        }

        if (this.emissao.paginasTermo != null) {
          this.paginasTermo = this.emissao.paginasTermo;
        }

        this.pedidoEncontrado = this.emissao.pedidoEncontrado;
        this.showSpinner = false;
      },
      err => {
        this.showSpinner = false;
       
        let error = null;
        if (err.error !== undefined) {
          error = err.error.message;
        }
        this.utilService.showError(error || err.message || err);
       }
    );
  }

  finalizarEmissao() {
    
    if (this.termoDialogRef !== undefined) {
      this.termoDialogRef.close();
    }

    this.showSpinner = true;    
    this.emissao.paginasTermo = null;
    this.emissao.idAgenteRegistro = this.idAgenteRegistro

    this.solicitacoesService.finalizarEmissao(this.emissao).subscribe(
      (emis) => {
        this.showSpinner = false;
        this.pedidoEncontrado = false;
        if (!emis.usuarioAtivado) {
          this.emissao.usuarioAtivado = emis.usuarioAtivado;
          this.emissao.token = emis.token;
        }    
        this.concluirEmissaoDialogRef = this.dialog.open(this.concluirEmissaoDialog, this.utilService.configuracaoDialog());
      },
      err => {
        this.showSpinner = false;
        this.toggleButton = true;
       
        let error = null;
        if (err.error !== undefined) {
          error = err.error.message;
        }
        this.utilService.showError(error || err.message || err);
      }
    );
  }
  
  exibirTermo() {
    if (this.paginasTermo.length == 0) {
      this.finalizarEmissao();
    } else {
      this.termoDialogRef = this.dialog.open(this.termoDialog, this.utilService.configuracaoDialog());
    }
  }

  fecharConcluirEmissaoDialog() {
    this.concluirEmissaoDialogRef.close();

    if (this.emissao.usuarioAtivado) {
      this.router.navigate(['/login']);
    } else {
      this.router.navigate(['/ativacao/' + this.emissao.token]);
    }    
  }

  fecharTermoDialog() {
    this.toggleButton = true;
    this.termoDialogRef.close();
  }
}